import { Component, input, output } from "@angular/core";
import { RouterLink } from "@angular/router";
import { FeatureFlagDirective } from "@dcc/shared/feature-flags/ui";
import { VdsIconButtonComponent } from "@dcc/vestas-design-system/angular/components/button";
import { VdsIconComponent } from "@dcc/vestas-design-system/angular/components/icon";
import { VdsMenu, VdsMenuItem, VdsMenuTrigger } from "@dcc/vestas-design-system/angular/components/menu";
import { VdsTooltipDirective } from "@dcc/vestas-design-system/angular/components/tooltip";
import { User } from "@dcc/vestas-online/domain";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
    selector: "vo-shell-user-menu",
    templateUrl: "./user-menu.component.html",
    host: {
        class: "block"
    },
    imports: [
        VdsMenu,
        VdsMenuTrigger,
        VdsMenuItem,
        VdsIconComponent,
        FeatureFlagDirective,
        RouterLink,
        TranslocoDirective,
        VdsIconButtonComponent,
        VdsTooltipDirective
    ]
})
export class UserMenuComponent {
    public user = input.required<User>();
    public triggerLabel = input<string>();

    public logout = output<void>();
    public toggleDrawer = output<void>();
}
